import common from '../_common/selectors';

var getSubstate = function getSubstate(state) {
  return state.areaRelations;
};

var getIndex = common.getIndex(getSubstate);
export default {
  getSubstate: getSubstate,
  getIndex: getIndex
};